/* ---------------------------------------------------------------------------
   NÜMASHOME — Lámpara del hero
   Dibuja por código (SVG, sin imágenes) la lámpara acanalada real y la
   enciende progresivamente según se baja la página.

   Pieza: cuerpo achatado con panza, acanalado fino de arriba abajo, hueca
   (la boca inferior está vacía), collarín cónico con textura granulada y
   cable de tela trenzado.

   Rendimiento (importante en móvil):
   · el trenzado del cable y las líneas de capa son <pattern>, no cientos de
     líneas sueltas; las motas del collarín son dos <path>, no 520 círculos;
   · durante el scroll no se mide nada del DOM salvo una posición: las alturas
     se cachean y sólo se recalculan al redimensionar;
   · el progreso se cuantiza al 1 %, así el SVG se repinta como mucho 100
     veces en todo el recorrido en vez de en cada fotograma.

   Todo lo ajustable está en G (geometría) y COLOR (material).
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';

  var G = {
    /* --- lienzo --------------------------------------------------------- */
    cx: 500,            // eje vertical de la pieza
    yTop: 360,          // borde superior del cuerpo
    A: 250,             // radio máximo (mitad de la anchura)
    proporcion: 0.871,  // alto / ancho: 200,86 / 230,51 mm de la pieza real

    /* --- perfil ---------------------------------------------------------
       Radio de la pantalla (1 = radio máximo) a 40 alturas, sacado
       directamente del 3MF de producción con herramientas/analiza-modelo.ps1
       (LAMPARA_MESA_PARTE_SUPERIOR_V1: Ø230,51 x 200,86 mm).              */
    perfil: [0.760, 0.810, 0.855, 0.896, 0.928, 0.950, 0.964, 0.973, 0.980, 0.984,
             0.988, 0.991, 0.993, 0.995, 0.997, 0.998, 0.999, 0.999, 1.000, 1.000,
             1.000, 1.000, 1.000, 0.999, 0.998, 0.997, 0.995, 0.993, 0.991, 0.988,
             0.984, 0.978, 0.971, 0.961, 0.947, 0.927, 0.896, 0.857, 0.811, 0.764],
    persp: 0.085,       // aplastamiento de las elipses (altura de cámara)
    ojo: 900,           // a qué distancia por debajo del canto está el ojo

    /* --- acanaladuras --------------------------------------------------- */
    nervios: 23,        // medido en el 3MF: 46 en toda la vuelta
    nerviosMovil: 15,   // en móvil se ve a un tercio de tamaño: con menos basta
    uNerv0: 0.010,      // dónde nacen (0 = justo en el borde superior)
    uNerv1: 0.992,      // dónde mueren
    ranuraGrados: 1.30, // semianchura de la ranura (paso real 7,83°)
    lomoGrados: 2.40,   // semianchura del brillo del lomo del nervio

    /* --- impresión ------------------------------------------------------ */
    alturaCapa: 5.4,    // separación de las líneas de capa

    /* --- luz de la escena ----------------------------------------------- */
    luzGrados: -24,     // de dónde entra la luz (negativo = desde la izquierda)

    /* --- soporte cónico superior (medido en el 3MF de techo:
           falda Ø126 mm · cuello Ø62,4 mm · alto 44 mm) ------------------- */
    colRadioAbajo: 0.546, // 62,97 / 115,26 mm
    colRadioArriba: 0.271,// 31,18 / 115,26 mm
    colAlto: 95,          // 44 mm a la escala del dibujo
    colLabio: 1.186,      // pestaña Ø149,4 sobre falda Ø126 mm (medida real)
    granos: 340,          // motas de la textura granulada
    granosMovil: 150,     // en móvil se ve pequeño: con menos basta

    /* --- encaje en el hueco ---------------------------------------------
       El lienzo se recalcula con la forma de su contenedor, así que la
       lámpara siempre ocupa la misma parte del hueco y el cable llena todo
       lo que quede por arriba, cuelgue lo que cuelgue.                    */
    alturaRel: 0.40,    // parte del ALTO del hueco que ocupa la lámpara
    ocupacionMax: 0.52, // tope de ancho en pantallas grandes
    // en móvil el hueco es estrecho y alto: con el tope de escritorio la
    // lámpara salía diminuta y con cable de sobra
    ocupacionMaxMovil: 0.78,
    anclaje: 0.58,      // a qué altura del hueco queda su canto inferior
    // En móvil el anclaje se mide en anchos, no en altos: el alto del hueco
    // cambia cada vez que el navegador oculta o muestra su barra al hacer
    // scroll, y con un anclaje en altos la lámpara se recolocaba de golpe en
    // mitad del gesto. El ancho no cambia nunca.
    anclajeMovil: 1.85,   // más alto = más cable colgando

    /* --- cable de tela --------------------------------------------------- */
    cableAncho: 20,
    trenzaPaso: 14,     // separación del trenzado

    /* --- boca inferior (hueca, sin nada dentro) -------------------------- */
    bocaR: 0.93,        // radio del hueco respecto al canto inferior

    muestras: 40
  };

  // Filamentos reales: pantalla en PLA Matte Ivory White (#FFFFFF) y soporte
  // en PLA Matte Bone White (#CBC6B8). Al ser mate, el sombreado es suave y
  // sin brillos especulares.
  var COLOR = {
    base:    [252, 252, 251],   // Ivory White a media luz
    alto:    [255, 255, 255],
    sombra:  [214, 211, 205],
    honda:   [172, 168, 160],
    collar:  [203, 198, 184],   // Bone White #CBC6B8
    collarS: [148, 143, 130],
    cable:   [244, 243, 240],
    calido1: [255, 235, 208],
    calido2: [255, 203, 150]
  };

  // una sola consulta de medios para todo el script
  var MOVIL = window.matchMedia('(max-width: 980px)');

  // ¿Puede el navegador animar ligado al scroll por su cuenta? Si puede, lo
  // hace el CSS en el hilo del compositor —sincronizado con el dedo— y este
  // script no toca ningún estilo: sólo dibuja la lámpara y la encaja. Si
  // escribiera estilos en línea, además, ganarían a la animación del CSS.
  var NATIVO = window.CSS && CSS.supports &&
               CSS.supports('animation-timeline', 'scroll()');

  /* ------------------------------------------------------------------ util */
  function el(tag, attrs) {
    var e = document.createElementNS(NS, tag), k;
    for (k in attrs) if (attrs[k] !== undefined && attrs[k] !== null) e.setAttribute(k, attrs[k]);
    return e;
  }
  function rgb(c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }
  function mezcla(a, b, t) {
    t = Math.max(0, Math.min(1, t));
    return [Math.round(a[0] + (b[0] - a[0]) * t),
            Math.round(a[1] + (b[1] - a[1]) * t),
            Math.round(a[2] + (b[2] - a[2]) * t)];
  }
  function asigna(a, b) { for (var k in b) a[k] = b[k]; return a; }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function suave(a, b, x) { var t = clamp01((x - a) / (b - a)); return t * t * (3 - 2 * t); }
  var rad = Math.PI / 180;
  // aleatorio reproducible: la textura sale siempre igual
  var semilla = 20260830;
  function azar() { semilla = (semilla * 1103515245 + 12345) % 2147483648; return semilla / 2147483648; }

  /* -------------------------------------------------------------- geometría */
  var H = 2 * G.A * G.proporcion;          // altura del cuerpo
  var yBot = G.yTop + H;                   // canto inferior
  // El observador está POR DEBAJO de la lámpara (se mira hacia arriba, como
  // en las fotos): por eso el frente de cada elipse queda por encima de su
  // centro y no se ve la corona plana de la boca superior.
  var yOjo = yBot + G.ojo;

  // radio a la altura u (0 arriba, 1 abajo), interpolando la tabla del perfil
  // con una curva suave (Catmull-Rom) para que no se noten los tramos.
  function radio(u) {
    var P = G.perfil, n = P.length - 1;
    var x = Math.max(0, Math.min(1, u)) * n;
    var i = Math.min(n - 1, Math.floor(x)), t = x - i;
    var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(n, i + 2)];
    var r = 0.5 * ((2 * p1) + (-p0 + p2) * t +
                   (2 * p0 - 5 * p1 + 4 * p2 - p3) * t * t +
                   (-p0 + 3 * p1 - 3 * p2 + p3) * t * t * t);
    return G.A * r;
  }
  function perfilY(u) { return G.yTop + H * u; }
  // Semieje menor de la elipse a la altura u. Sale negativo (frente arriba)
  // porque toda la pieza queda por encima del ojo.
  function elipseY(u) { return G.persp * radio(u) * (perfilY(u) - yOjo) / G.ojo; }
  function P(u, th) {
    var r = radio(u), s = Math.sin(th * rad), c = Math.cos(th * rad);
    return [G.cx + r * s, perfilY(u) + elipseY(u) * c];
  }
  function d(pts) {
    var s = 'M', i;
    for (i = 0; i < pts.length; i++) s += (i ? 'L' : '') + pts[i][0].toFixed(1) + ' ' + pts[i][1].toFixed(1);
    return s + 'Z';
  }
  // curva vertical sobre la superficie a un ángulo dado (sin cerrar)
  function curva(th, u0, u1) {
    var s = '', i, N = G.muestras, p;
    for (i = 0; i <= N; i++) {
      p = P(u0 + (u1 - u0) * i / N, th);
      s += (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1);
    }
    return s;
  }
  // franja de superficie entre dos ángulos, entre las alturas u0 y u1
  function banda(thL, thR, u0, u1) {
    if (u0 === undefined) { u0 = 0; u1 = 1; }
    var pts = [], i, N = G.muestras, M = 10;
    for (i = 0; i <= N; i++) pts.push(P(u0 + (u1 - u0) * i / N, thL));
    for (i = 1; i < M; i++) pts.push(P(u1, thL + (thR - thL) * i / M));
    for (i = N; i >= 0; i--) pts.push(P(u0 + (u1 - u0) * i / N, thR));
    for (i = M - 1; i > 0; i--) pts.push(P(u0, thL + (thR - thL) * i / M));
    return d(pts);
  }
  // iluminación difusa de la escena para un ángulo dado
  function claridad(th) {
    var lam = Math.max(0, Math.cos((th - G.luzGrados) * rad));
    var canto = 0.68 + 0.32 * Math.pow(Math.max(0, Math.cos(th * rad)), 0.55);
    return Math.pow(lam, 0.8) * canto;
  }
  function tono(l) {
    return l < 0.62 ? mezcla(COLOR.sombra, COLOR.base, l / 0.62)
                    : mezcla(COLOR.base, COLOR.alto, (l - 0.62) / 0.38);
  }
  // círculo como subtrazado, para agrupar muchas motas en un solo <path>
  function circuloPath(x, y, r) {
    return 'M' + x.toFixed(1) + ' ' + y.toFixed(1) +
           'm-' + r.toFixed(2) + ' 0' +
           'a' + r.toFixed(2) + ' ' + r.toFixed(2) + ' 0 1 0 ' + (2 * r).toFixed(2) + ' 0' +
           'a' + r.toFixed(2) + ' ' + r.toFixed(2) + ' 0 1 0 ' + (-2 * r).toFixed(2) + ' 0';
  }

  /* ------------------------------------------------------------ construcción */
  function dibujar(host, clase, etiqueta) {
    var uid = 'nl' + Math.random().toString(36).slice(2, 7);  // ids únicos
    var svg = el('svg', {
      viewBox: '0 0 1000 1160',    // se recalcula en encajar()
      preserveAspectRatio: 'xMidYMid meet',
      class: 'numa-lampara__svg ' + clase,
      role: etiqueta ? 'img' : 'presentation',
      'aria-hidden': etiqueta ? null : 'true',
      'aria-label': etiqueta || null
    });
    var defs = el('defs');
    svg.appendChild(defs);

    // elipseY es negativo (vista desde abajo): para dibujar elipses hace
    // falta el valor absoluto, y el arco de delante pasa a ser el de arriba.
    var rBot = radio(1), ryBot = Math.abs(elipseY(1));
    var rBoca = rBot * G.bocaR, ryBoca = ryBot * G.bocaR;
    var yBoca = yBot - 5;
    var aC = G.cableAncho / 2;

    function id(x) { return uid + x; }
    function url(x) { return 'url(#' + uid + x + ')'; }
    function grad(tipo, nombre, stops, attrs) {
      var g = el(tipo, asigna({ id: id(nombre), gradientUnits: 'userSpaceOnUse' }, attrs));
      stops.forEach(function (s) {
        g.appendChild(el('stop', { offset: s[0], 'stop-color': s[1], 'stop-opacity': s[2] }));
      });
      defs.appendChild(g);
    }

    /* --- degradado del cuerpo: cilindro iluminado desde la ventana ----- */
    var stopsCuerpo = [], i;
    for (i = 0; i <= 24; i++) {
      var f = i / 24;
      var th = Math.asin(Math.max(-1, Math.min(1, f * 2 - 1))) / rad;
      stopsCuerpo.push([f.toFixed(3), rgb(tono(claridad(th))), 1]);
    }
    grad('linearGradient', 'Cuerpo', stopsCuerpo, { x1: G.cx - G.A, y1: 0, x2: G.cx + G.A, y2: 0 });

    /* --- resto de degradados ------------------------------------------- */
    grad('radialGradient', 'Halo',
      [[0, 'rgb(255,225,185)', .46], [.20, 'rgb(255,202,145)', .22],
       [.45, 'rgb(255,181,112)', .075], [.72, 'rgb(255,170,90)', .012],
       [1, 'rgb(255,170,90)', 0]],
      { cx: G.cx, cy: yBot - 28, r: 365 });

    // hueco interior, apagado y encendido
    grad('radialGradient', 'HuecoOff', [[0, 'rgb(126,113,98)', 1], [.6, 'rgb(99,88,76)', 1], [1, 'rgb(74,64,55)', 1]],
      { cx: G.cx, cy: yBoca - 8, r: rBoca * 1.3 });
    grad('radialGradient', 'Hueco', [[0, 'rgb(255,247,232)', 1], [.45, 'rgb(255,220,170)', 1], [1, 'rgb(214,148,86)', 1]],
      { cx: G.cx, cy: yBoca - 8, r: rBoca * 1.3 });
    // canto inferior visto desde abajo: no le llega la luz de la ventana
    grad('linearGradient', 'Canto', [[0, rgb(mezcla(COLOR.sombra, COLOR.honda, .12)), 1],
                                     [.42, rgb(mezcla(COLOR.base, COLOR.sombra, .28)), 1],
                                     [1, rgb(mezcla(COLOR.sombra, COLOR.honda, .32)), 1]],
      { x1: G.cx - rBot, y1: 0, x2: G.cx + rBot, y2: 0 });
    grad('linearGradient', 'AO', [[0, 'rgb(104,88,72)', .05], [.18, 'rgb(104,88,72)', 0],
                                  [.76, 'rgb(104,88,72)', 0], [1, 'rgb(104,88,72)', .20]],
      { x1: 0, y1: G.yTop, x2: 0, y2: yBot + ryBot });
    grad('linearGradient', 'Luz', [[0, rgb(COLOR.calido1), .05], [.45, rgb(COLOR.calido1), .30],
                                   [.85, rgb(COLOR.calido2), .70], [1, rgb(COLOR.calido2), .82]],
      { x1: 0, y1: G.yTop, x2: 0, y2: yBot + ryBot });
    grad('linearGradient', 'Cable', [[0, rgb(mezcla(COLOR.cable, COLOR.honda, .40)), 1],
                                     [.34, rgb(COLOR.cable), 1],
                                     [1, rgb(mezcla(COLOR.cable, COLOR.honda, .30)), 1]],
      { x1: G.cx - aC, y1: 0, x2: G.cx + aC, y2: 0 });
    grad('linearGradient', 'Collar', [[0, rgb(COLOR.collarS), 1], [.30, rgb(COLOR.collar), 1],
                                      [.52, rgb(mezcla(COLOR.collar, COLOR.alto, .55)), 1],
                                      [1, rgb(mezcla(COLOR.collarS, [96, 92, 86], .35)), 1]],
      { x1: G.cx - G.A * G.colRadioAbajo, y1: 0, x2: G.cx + G.A * G.colRadioAbajo, y2: 0 });

    /* --- patrones: trenzado del cable y líneas de capa -------------------
       Se repiten solos, así que son un nodo cada uno en lugar de cientos. */
    var patTrenza = el('pattern', { id: id('Trenza'), patternUnits: 'userSpaceOnUse',
      x: G.cx - aC, y: 0, width: G.cableAncho, height: G.trenzaPaso * 2 });
    patTrenza.appendChild(el('line', { x1: -2, y1: 0, x2: G.cableAncho + 2, y2: G.trenzaPaso * 0.8,
      stroke: 'rgba(255,255,255,.55)', 'stroke-width': 2.1 }));
    patTrenza.appendChild(el('line', { x1: -2, y1: G.trenzaPaso * 1.8, x2: G.cableAncho + 2, y2: G.trenzaPaso,
      stroke: 'rgba(150,143,132,.30)', 'stroke-width': 2.1 }));
    defs.appendChild(patTrenza);

    var patCapas = el('pattern', { id: id('Capas'), patternUnits: 'userSpaceOnUse',
      x: 0, y: G.yTop, width: 8, height: G.alturaCapa });
    patCapas.appendChild(el('rect', { x: 0, y: 0, width: 8, height: 1, fill: 'rgba(126,104,82,0.12)' }));
    defs.appendChild(patCapas);

    // máscara que difumina las acanaladuras al llegar a los bordes
    var yN0 = perfilY(G.uNerv0), yN1 = perfilY(G.uNerv1);
    grad('linearGradient', 'FundeG', [[0, '#fff', 0], [.10, '#fff', 1], [.92, '#fff', 1], [1, '#fff', 0]],
      { x1: 0, y1: yN0, x2: 0, y2: yN1 });
    var mFunde = el('mask', { id: id('Funde'), maskUnits: 'userSpaceOnUse', x: -3000, y: -6000, width: 7000, height: 12000 });
    mFunde.appendChild(el('rect', { x: -3000, y: yN0 - 4, width: 7000, height: yN1 - yN0 + 8, fill: url('FundeG') }));
    defs.appendChild(mFunde);

    var silueta = banda(-90, 90);
    var cpSil = el('clipPath', { id: id('Sil'), clipPathUnits: 'userSpaceOnUse' });
    cpSil.appendChild(el('path', { d: silueta }));
    defs.appendChild(cpSil);

    /* --- 1 · halo cálido detrás ---------------------------------------- */
    var gHalo = el('g', { class: 'nl-halo' });
    gHalo.appendChild(el('rect', { x: -3000, y: -6000, width: 7000, height: 12000, fill: url('Halo') }));
    svg.appendChild(gHalo);

    /* --- 2 · cable de tela ---------------------------------------------- */
    var yCol1 = G.yTop;                         // la pestaña apoya en la boca
    var yCol0 = yCol1 - G.colAlto;              // cuello del collarín
    var yCable = yCol0 + 16;
    // el cable arranca muy por encima del lienzo: así puede colgar lo que
    // haga falta sin que su longitud afecte al tamaño de la lámpara
    var yCableIni = yCable - 6000;
    var gCable = el('g');
    var cajaCable = { x: G.cx - aC, y: yCableIni, width: G.cableAncho, height: yCable - yCableIni, rx: aC };
    gCable.appendChild(el('rect', asigna({ fill: url('Cable') }, cajaCable)));
    gCable.appendChild(el('rect', asigna({ fill: url('Trenza') }, cajaCable)));
    svg.appendChild(gCable);

    /* --- 3 · cuerpo ----------------------------------------------------- */
    var gCuerpo = el('g');
    gCuerpo.appendChild(el('path', { d: silueta, fill: url('Cuerpo') }));

    // acanaladuras: ranuras en sombra + lomos con brillo. En móvil la pieza
    // se ve a un tercio de tamaño, así que con menos nervios el resultado es
    // el mismo a la vista y hay bastante menos que rasterizar.
    var nNervios = MOVIL.matches ? G.nerviosMovil : G.nervios;
    var paso = 180 / nNervios;
    var gRanuras = el('g', { mask: url('Funde') });
    var gLomos = el('g', { mask: url('Funde') });

    for (var k = 0; k <= nNervios; k++) {
      var thS = -90 + k * paso;                            // ranura
      var aS = (0.34 + 0.66 * claridad(thS)) * 0.80;
      var xa = G.cx + G.A * Math.sin((thS - G.ranuraGrados) * rad);
      var xb = G.cx + G.A * Math.sin((thS + G.ranuraGrados) * rad);
      if (xb - xa < 1.2) {
        // Hacia el canto los nervios se comprimen a menos de un píxel: como
        // relleno desaparecerían, así que ahí la ranura se traza como línea.
        gRanuras.appendChild(el('path', {
          d: curva(thS, G.uNerv0, G.uNerv1), fill: 'none',
          stroke: rgb(COLOR.honda), 'stroke-opacity': (aS * 0.9).toFixed(3), 'stroke-width': 1.3
        }));
      } else {
        // en coordenadas del propio nervio: así el degradado cae siempre
        // dentro de la ranura, sea cual sea su anchura y su posición.
        grad('linearGradient', 'R' + k, [[0, rgb(COLOR.honda), 0], [.5, rgb(COLOR.honda), aS.toFixed(3)],
                                         [1, rgb(COLOR.honda), 0]],
          { x1: 0, y1: 0, x2: 1, y2: 0, gradientUnits: 'objectBoundingBox' });
        gRanuras.appendChild(el('path', {
          d: banda(thS - G.ranuraGrados, thS + G.ranuraGrados, G.uNerv0, G.uNerv1), fill: url('R' + k)
        }));
      }

      if (k === nNervios) break;
      var thC = thS + paso / 2;                            // lomo del nervio
      var aL = Math.pow(claridad(thC), 1.5) * 0.38;
      var xc = G.cx + G.A * Math.sin((thC - G.lomoGrados) * rad);
      var xd = G.cx + G.A * Math.sin((thC + G.lomoGrados) * rad);
      if (xd - xc < 1.2) {
        gLomos.appendChild(el('path', {
          d: curva(thC, G.uNerv0, G.uNerv1), fill: 'none',
          stroke: rgb(COLOR.alto), 'stroke-opacity': (aL * 0.9).toFixed(3), 'stroke-width': 1.3
        }));
      } else {
        grad('linearGradient', 'M' + k, [[0, rgb(COLOR.alto), 0], [.5, rgb(COLOR.alto), aL.toFixed(3)],
                                         [1, rgb(COLOR.alto), 0]],
          { x1: 0, y1: 0, x2: 1, y2: 0, gradientUnits: 'objectBoundingBox' });
        gLomos.appendChild(el('path', {
          d: banda(thC - G.lomoGrados, thC + G.lomoGrados, G.uNerv0, G.uNerv1), fill: url('M' + k)
        }));
      }
    }
    gCuerpo.appendChild(gLomos);
    gCuerpo.appendChild(gRanuras);

    // líneas de capa de impresión: un rectángulo con el patrón, recortado
    var gCapas = el('g', { class: 'nl-capas', 'clip-path': url('Sil') });
    gCapas.appendChild(el('rect', { x: G.cx - G.A - 12, y: G.yTop, width: 2 * G.A + 24,
      height: (yBot + ryBot) - G.yTop, fill: url('Capas') }));
    gCuerpo.appendChild(gCapas);

    // retroiluminación del material translúcido
    gCuerpo.appendChild(el('path', { d: silueta, fill: url('Luz'), class: 'nl-luz' }));
    gCuerpo.appendChild(el('path', { d: silueta, fill: url('AO') }));
    svg.appendChild(gCuerpo);

    /* --- 3b · collarín con textura granulada ---------------------------- */
    var rxC1 = G.A * G.colRadioAbajo, ryC1 = Math.abs(rxC1 * G.persp * (yCol1 - yOjo) / G.ojo);
    var rxC0 = G.A * G.colRadioArriba, ryC0 = Math.max(2, Math.abs(rxC0 * G.persp * (yCol0 - yOjo) / G.ojo));
    var qx = (rxC0 + rxC1) * 0.40, qy = yCol0 + G.colAlto * 0.45;
    // visto desde abajo: la boca del cuello se cierra por arriba (arco de
    // atrás) y el canto de la falda se curva hacia arriba por delante
    var dCollar = 'M ' + (G.cx - rxC1) + ' ' + yCol1 +
                  ' Q ' + (G.cx - qx) + ' ' + qy + ' ' + (G.cx - rxC0) + ' ' + yCol0 +
                  ' A ' + rxC0 + ' ' + ryC0 + ' 0 0 1 ' + (G.cx + rxC0) + ' ' + yCol0 +
                  ' Q ' + (G.cx + qx) + ' ' + qy + ' ' + (G.cx + rxC1) + ' ' + yCol1 +
                  ' A ' + rxC1 + ' ' + ryC1 + ' 0 0 1 ' + (G.cx - rxC1) + ' ' + yCol1 + ' Z';

    // labio: el reborde que sobresale por debajo del collarín
    var rxL = rxC1 * G.colLabio, ryL = ryC1 * G.colLabio, yL = yCol1 - 1;

    var cpCol = el('clipPath', { id: id('Col'), clipPathUnits: 'userSpaceOnUse' });
    cpCol.appendChild(el('path', { d: dCollar }));
    cpCol.appendChild(el('ellipse', { cx: G.cx, cy: yL, rx: rxL, ry: ryL }));
    defs.appendChild(cpCol);

    var gCol = el('g');
    gCol.appendChild(el('ellipse', { cx: G.cx, cy: yL + 3, rx: rxL, ry: ryL,
      fill: 'rgba(120,104,88,.05)' }));                    // sombra sobre la pantalla
    // La pestaña se ve por su cara inferior: Bone White en sombra suave,
    // sin el degradado del cono (que es para una superficie vertical).
    grad('linearGradient', 'Pestana', [[0, rgb(mezcla(COLOR.collar, COLOR.collarS, .45)), 1],
                                       [.38, rgb(COLOR.collar), 1],
                                       [1, rgb(mezcla(COLOR.collar, COLOR.collarS, .55)), 1]],
      { x1: G.cx - rxL, y1: 0, x2: G.cx + rxL, y2: 0 });
    gCol.appendChild(el('ellipse', { cx: G.cx, cy: yL, rx: rxL, ry: ryL, fill: url('Pestana') }));
    gCol.appendChild(el('path', { d: dCollar, fill: url('Collar') }));

    // textura granulada: todas las motas claras en un <path> y las oscuras
    // en otro, en vez de cientos de <circle>
    var nGranos = MOVIL.matches ? G.granosMovil : G.granos;
    var dClaro = '', dOscuro = '';
    for (var m = 0; m < nGranos; m++) {
      var gx = G.cx - rxC1 + azar() * rxC1 * 2;
      var gy = yCol0 - 4 + azar() * (yCol1 - yCol0 + 10);
      var sub = circuloPath(gx, gy, 0.45 + azar() * 1.0);
      if (azar() > 0.45) dClaro += sub; else dOscuro += sub;
    }
    var gGrano = el('g', { 'clip-path': url('Col') });
    gGrano.appendChild(el('path', { d: dClaro, fill: 'rgba(255,255,255,.34)' }));
    gGrano.appendChild(el('path', { d: dOscuro, fill: 'rgba(122,114,100,.26)' }));
    gCol.appendChild(gGrano);
    // espesor del labio: su canto queda en sombra (arco de delante, arriba)
    gCol.appendChild(el('path', {
      d: 'M ' + (G.cx - rxL) + ' ' + yL + ' A ' + rxL + ' ' + ryL + ' 0 0 1 ' + (G.cx + rxL) + ' ' + yL,
      fill: 'none', stroke: 'rgba(128,120,108,.45)', 'stroke-width': 3
    }));
    // El soporte va DEBAJO de la pantalla: la parte que queda por detrás del
    // borde de la boca no se ve, igual que en la pieza montada.
    svg.insertBefore(gCol, gCuerpo);

    /* --- 4 · boca inferior: hueca, sin nada dentro ---------------------- */
    var gBase = el('g');
    gBase.appendChild(el('ellipse', { cx: G.cx, cy: yBot, rx: rBot, ry: ryBot, fill: url('Canto') }));
    gBase.appendChild(el('ellipse', { cx: G.cx, cy: yBoca, rx: rBoca, ry: ryBoca, fill: url('HuecoOff') }));
    gBase.appendChild(el('ellipse', { cx: G.cx, cy: yBoca, rx: rBoca, ry: ryBoca, fill: url('Hueco'),
      class: 'nl-interior' }));
    // canto del hueco: mirando desde abajo, el borde de delante es el de
    // arriba (ahí da la luz) y el de atrás, el de abajo (queda en sombra)
    gBase.appendChild(el('path', {
      d: 'M ' + (G.cx - rBoca) + ' ' + yBoca + ' A ' + rBoca + ' ' + ryBoca + ' 0 0 0 ' + (G.cx + rBoca) + ' ' + yBoca,
      fill: 'none', stroke: 'rgba(96,80,64,.30)', 'stroke-width': 4
    }));
    gBase.appendChild(el('path', {
      d: 'M ' + (G.cx - rBoca) + ' ' + yBoca + ' A ' + rBoca + ' ' + ryBoca + ' 0 0 1 ' + (G.cx + rBoca) + ' ' + yBoca,
      fill: 'none', stroke: 'rgb(255,238,210)', 'stroke-width': 5, class: 'nl-labio'
    }));
    svg.appendChild(gBase);

    host.appendChild(svg);
    return svg;
  }

  /* Ajusta el lienzo a la forma del hueco. El tamaño lo manda la ALTURA
     disponible (si mandara el ancho, en pantallas anchas la lámpara saldría
     enorme), con un tope de anchura por si el hueco es muy estrecho. El canto
     inferior queda a la altura `anclaje` y lo de encima lo llena el cable. */
  function encajar(svg, host) {
    var w = host.clientWidth, h = host.clientHeight;
    if (!w || !h) return;

    var movil = MOVIL.matches;
    var anchoVB, altoVB, y0;

    if (movil) {
      // El tamaño y la posición se derivan SÓLO del ancho, que no cambia al
      // aparecer o desaparecer la barra del navegador. El alto del lienzo
      // acompaña al del hueco, así que la escala se mantiene y la lámpara
      // queda siempre a la misma distancia del borde de arriba: ya no se
      // recoloca a mitad de scroll.
      anchoVB = (2 * G.A) / G.ocupacionMaxMovil;
      altoVB = anchoVB * h / w;
      y0 = yBot - anchoVB * G.anclajeMovil;

      // La pieza tiene que caber SIEMPRE. El anclaje se mide en anchos, y en
      // una pantalla cuadrada (una tableta) el lienzo es proporcionalmente
      // más bajo: con el anclaje a secas el canto inferior se quedaba fuera y
      // la lámpara aparecía partida por la mitad. Estos dos topes lo impiden.
      var yFin = yBot + Math.abs(elipseY(1)) + 18;   // canto inferior + aire
      var yIni = G.yTop - G.colAlto - 24;            // cuello del soporte
      if (y0 + altoVB < yFin) y0 = yFin - altoVB;    // que no se corte abajo
      if (y0 > yIni) y0 = yIni;                      // ni por arriba
    } else {
      var altoPieza = (yBot - Math.min(0, elipseY(1))) - (G.yTop - G.colAlto - 10);
      altoVB = altoPieza / G.alturaRel;
      anchoVB = altoVB * w / h;
      var anchoMin = (2 * G.A) / G.ocupacionMax;
      if (anchoVB < anchoMin) { anchoVB = anchoMin; altoVB = anchoVB * h / w; }
      y0 = yBot - altoVB * G.anclaje;
    }

    svg.setAttribute('viewBox',
      (G.cx - anchoVB / 2).toFixed(1) + ' ' + y0.toFixed(1) + ' ' +
      anchoVB.toFixed(1) + ' ' + altoVB.toFixed(1));
  }

  /* ----------------------------------------------------------- encendido */
  function iniciar(host) {
    if (host.dataset.numaLista) return;
    host.dataset.numaLista = '1';

    // Dos copias superpuestas: una apagada y otra encendida. Al bajar sólo
    // se funde la de arriba sobre la de abajo. Así el navegador no repinta
    // el dibujo ni una sola vez durante el scroll —sólo compone dos capas ya
    // rasterizadas—, que es lo que quita los tirones en el móvil.
    var svgOff = dibujar(host, 'numa-lampara__svg--off', 'Lámpara de techo impresa en 3D');
    var svgOn = dibujar(host, 'numa-lampara__svg--on');

    // Con el hero a pantalla completa el recorrido lo marca el contenedor
    // fijo; si no, se usa la altura del propio hero.
    var fijo = host.closest('[data-numa-hero]');
    var escena = fijo ? fijo.querySelector('[data-numa-escena]') : null;
    var zona = fijo || host.closest('.hero') || host.parentElement;
    var cabecera = document.querySelector('.site-header');

    // Referencias a cada pieza que se anima. Los valores se escriben en el
    // estilo de CADA elemento, nunca como variable CSS en un ancestro:
    // medido en esta misma página, escribir una custom property en .hero-fijo
    // cuesta 2 ms por fotograma (invalida el estilo de todo el subárbol,
    // ~700 nodos) frente a 0,01 ms escribiendo el estilo directamente.
    var pieza = fijo ? {
      copia:    fijo.querySelector('.hero-copy'),
      ficha:    fijo.querySelector('.hero-ficha'),
      anochece: fijo.querySelector('.hero-fijo__anochece'),
      luz:      fijo.querySelector('.hero-fijo__luz'),
      aviso:    fijo.querySelector('.hero-fijo__aviso'),
      visual:   fijo.querySelector('.hero-visual--lampara')
    } : {};

    // Medidas cacheadas: durante el scroll NO se consulta el DOM más que la
    // posición de la zona. Antes se leían offsetHeight y se escribía una
    // variable CSS de altura en cada fotograma, lo que forzaba a recalcular
    // el diseño de la página entera 60 veces por segundo.
    var altoCabecera = -1, recorrido = 0, inicioDoc = 0;
    var ultimo = -1, reintento = false;

    // Suavizado. La animación no copia el scroll, lo persigue: cada muesca de
    // rueda mueve la página ~100 px de golpe y, atado 1:1, el encendido daba
    // un salto seco aunque el navegador fuese a 144 fps. Con la persecución
    // el valor llega al destino en ~0,25 s de forma continua.
    var destino = 0, valor = 0, animando = false, tPrevio = 0;
    var SUAVE = 0.16;                 // 0 = sin suavizado · 1 = instantáneo
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

    function medir() {
      reintento = false;
      if (fijo) {
        var hc = cabecera ? cabecera.offsetHeight : 0;
        if (hc && hc !== altoCabecera) {          // sólo si cambió de verdad
          altoCabecera = hc;
          fijo.style.setProperty('--nh-header', hc + 'px');
        }
        recorrido = escena ? (fijo.offsetHeight - escena.offsetHeight) : 0;
      } else {
        recorrido = zona.offsetHeight * 0.8;
      }
      anchoPrevio = host.clientWidth;
      altoPrevio = host.clientHeight;
      // Posición del hero dentro del documento. Se guarda AQUÍ para no tener
      // que preguntarla durante el scroll: getBoundingClientRect() obliga al
      // navegador a recalcular el diseño, y hacerlo en cada gesto (justo
      // después de que el bucle haya escrito estilos) es lo que atasca el
      // hilo principal y hace que la página baje a tirones.
      inicioDoc = zona.getBoundingClientRect().top + (window.pageYOffset || 0);
      encajar(svgOff, host);
      encajar(svgOn, host);
      ultimo = -1;                                // fuerza un repintado
      if (NATIVO) return;                         // del resto se encarga el CSS
      if (recorrido > 0) {
        destino = progreso();
        valor = destino;                          // al medir no se persigue
        pintar(valor);
      }
    }

    // Sólo lee window.pageYOffset, que no obliga a recalcular nada.
    function progreso() {
      return clamp01(((window.pageYOffset || 0) - inicioDoc) / recorrido);
    }

    // Lee dónde está el scroll y arranca la persecución si hace falta.
    function alScroll() {
      // Si la primera medida se tomó antes de que el diseño estuviese
      // asentado (fuentes, imágenes), el recorrido sale a cero. Al cachear
      // las medidas eso se quedaría así para siempre: se vuelve a medir.
      if (recorrido <= 0) {
        if (!reintento) { reintento = true; setTimeout(medir, 80); }
        return;
      }
      destino = progreso();
      if (quieto.matches) { valor = destino; pintar(valor); return; }
      if (!animando) { animando = true; tPrevio = 0; requestAnimationFrame(perseguir); }
    }

    function perseguir(t) {
      var dt = tPrevio ? Math.min(64, t - tPrevio) : 16.7;
      tPrevio = t;
      var d = destino - valor;
      if (Math.abs(d) < 0.0004) {          // ya ha llegado: se para el bucle
        valor = destino;
        animando = false;
        pintar(valor);
        return;
      }
      // factor independiente de la tasa de refresco: se comporta igual a
      // 60 Hz que a 144 Hz
      valor += d * (1 - Math.pow(1 - SUAVE, dt / 16.7));
      pintar(valor);
      requestAnimationFrame(perseguir);
    }

    function pintar(p) {
      p = Math.round(p * 1000) / 1000;
      if (p === ultimo) return;
      ultimo = p;

      // fundido entre la copia apagada y la encendida
      svgOn.style.opacity = suave(0.02, 0.80, p).toFixed(3);

      if (!fijo) return;
      var dim = suave(0.12, 0.88, p);
      var op = (1 - suave(0.16, 0.52, p)).toFixed(3);
      var mov = 'translate3d(0,' + (-52 * suave(0.16, 0.62, p)).toFixed(1) + 'px,0)';

      if (pieza.anochece) pieza.anochece.style.opacity = (dim * 0.78).toFixed(3);
      if (pieza.luz) pieza.luz.style.opacity = (dim * 0.82).toFixed(3);
      if (pieza.copia) { pieza.copia.style.opacity = op; pieza.copia.style.transform = mov; }
      if (pieza.ficha) { pieza.ficha.style.opacity = op; pieza.ficha.style.transform = mov; }
      if (pieza.aviso) pieza.aviso.style.opacity = (1 - suave(0.01, 0.12, p)).toFixed(3);
      // sólo desplazamiento, sin scale: escalar obliga a volver a rasterizar
      // los dos dibujos en cada fotograma, y el zoom era de apenas un 4 %
      if (false && pieza.visual) {  // desactivado: dejaba el cable colgando
        pieza.visual.style.transform = 'translate3d(0,' + (14 * p).toFixed(1) + 'px,0)';
      }
    }

    // En el móvil, al bajar se oculta la barra del navegador y al subir
    // reaparece: cada vez cambia el alto del viewport y salta un resize. Si
    // se atiende, se vuelve a encajar el dibujo (cambiar el viewBox obliga a
    // rasterizar de nuevo los dos SVG enteros) EN MEDIO DEL SCROLL, y eso es
    // un tirón. Los cambios de alto pequeños con el ancho igual se ignoran.
    var remedir = null, anchoPrevio = 0, altoPrevio = 0;
    var TOLERANCIA_ALTO = 160;                    // barra del navegador

    function alRedimensionar(forzar) {
      if (forzar !== true) {
        var w = host.clientWidth, h = host.clientHeight;
        if (w === anchoPrevio && Math.abs(h - altoPrevio) < TOLERANCIA_ALTO) return;
      }
      clearTimeout(remedir);
      remedir = setTimeout(medir, 120);           // el resize no necesita prisa
    }
    function forzarMedida() { alRedimensionar(true); }

    if (!NATIVO) {
      addEventListener('scroll', alScroll, { passive: true });
      // en captura, por si el scroll ocurre dentro de un contenedor y no en
      // la ventana (los eventos scroll de un elemento no burbujean)
      document.addEventListener('scroll', alScroll, { passive: true, capture: true });
    }
    addEventListener('resize', function () { alRedimensionar(); }, { passive: true });
    // el giro de pantalla sí cambia de verdad la forma del hueco
    addEventListener('orientationchange', forzarMedida, { passive: true });
    // el diseño se asienta después: imágenes y fuentes
    addEventListener('load', forzarMedida);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(forzarMedida);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { alRedimensionar(); });
      ro.observe(host);
      if (escena) ro.observe(escena);
    }

    medir();
    ponerRegulador(host);
    host.classList.add('numa-lampara--lista');
  }

  /* --------------------------------------------------------- diagnóstico
     Para localizar en un móvil real qué parte provoca los tirones, se puede
     desactivar cada pieza desde la URL, sin tocar el código:

       ?nh=sin-luz        quita la penumbra y el baño de luz
       ?nh=sin-lampara    quita el dibujo entero
       ?nh=sin-sticky     la escena deja de quedarse fija
       ?nh=sin-animacion  todo queda quieto (nada se anima al bajar)

     Se baja con cada uno y se compara: la que quite el tirón es la culpable.
  --------------------------------------------------------------------- */
  var DIAG = (location.search.match(/[?&]nh=([a-z-]+)/) || [])[1] || '';
  if (DIAG) document.documentElement.classList.add('nh-' + DIAG);

  /* ------------------------------------------------------------- anclas
     El botón «Cómo lo hacemos» apunta a #proceso, pero la sección se llama
     en realidad «proceso-template--…__process-numa»: Shopify le pega su
     identificador único, así que ese ancla no existe y el enlace no llevaba
     a ninguna parte. Aquí se crea el ancla que falta, para no tener que
     tocar la sección (su CSS interno depende de ese id y no se puede
     renombrar). Se hace igual con cualquier otro enlace de la página que
     apunte a una sección cuyo id empiece igual.                          */
  function repararAnclas() {
    var enlaces = document.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < enlaces.length; i++) {
      var destino = enlaces[i].getAttribute('href').slice(1);
      if (!destino || document.getElementById(destino)) continue;

      var seccion = document.querySelector('[id^="' + destino + '-"]');
      if (!seccion) continue;

      var ancla = document.createElement('span');
      ancla.id = destino;
      ancla.setAttribute('aria-hidden', 'true');
      ancla.style.cssText = 'display:block;scroll-margin-top:90px';
      seccion.parentNode.insertBefore(ancla, seccion);
    }
  }

  /* --------------------------------------------------------- regulador
     Un pequeño mando para encender y apagar la lámpara a mano. Mientras no
     se toca, la pieza sigue su animación (el scroll en escritorio, la
     entrada en móvil). En cuanto se usa, manda el mando: se marca el hero
     como «manual» y el CSS desactiva las animaciones para que no peleen.

     Es un <input type="range"> de verdad, así que funciona con el teclado
     (flechas, inicio y fin) y lo anuncian los lectores de pantalla.        */
  function ponerRegulador(host) {
    /* Sólo en móvil y tablet. En escritorio la lámpara se enciende y se
       apaga con el scroll, y el mando se peleaba con eso: en cuanto se
       tocaba, el hero pasaba a modo manual y la animación del scroll se
       quedaba desactivada para el resto de la visita. */
    if (window.matchMedia("(min-width: 981px)").matches) return;

    var escena = host.closest('[data-numa-escena]') || host.closest('.hero');
    var fijo = host.closest('[data-numa-hero]');
    if (!escena || escena.querySelector('.numa-mando')) return;

    var svgOn = host.querySelector('.numa-lampara__svg--on');
    var luz = fijo && fijo.querySelector('.hero-fijo__luz');
    var penumbra = fijo && fijo.querySelector('.hero-fijo__anochece');
    if (!svgOn) return;

    var caja = document.createElement('div');
    caja.className = 'numa-mando';
    caja.innerHTML =
      '<span class="numa-mando__k">Luz</span>' +
      '<input class="numa-mando__ctrl" type="range" min="0" max="100" step="1" value="0"' +
      ' aria-label="Intensidad de la lámpara">' +
      '<span class="numa-mando__v">0<span aria-hidden="true">%</span></span>';

    var ctrl = caja.querySelector('.numa-mando__ctrl');
    var valor = caja.querySelector('.numa-mando__v');

    function aplicar(pct) {
      var f = pct / 100;
      caja.style.setProperty('--nm-pct', pct + '%');
      valor.firstChild.nodeValue = pct;
      svgOn.style.opacity = f.toFixed(3);
      // cuanto más se sube la lámpara, más se apaga la luz de la sala: al
      // llegar al tope la escena queda de noche, como al bajar la página
      if (luz) luz.style.opacity = (f * 0.82).toFixed(3);
      if (penumbra) penumbra.style.opacity = (f * 0.78).toFixed(3);
    }

    // Marca el hero como manual para que el CSS aparte las animaciones. No
    // toca el valor del mando: eso sólo se hace ANTES de empezar a mover.
    function activar() {
      if (caja.dataset.activo) return;
      caja.dataset.activo = '1';
      (fijo || escena).classList.add('numa-manual');
    }

    // Al ir a cogerlo, el mando se pone donde esté la lámpara en ese momento,
    // para que no dé un salto al primer movimiento.
    function sincronizar() {
      if (caja.dataset.activo) return;
      var actual = Math.round((parseFloat(getComputedStyle(svgOn).opacity) || 0) * 100);
      activar();
      ctrl.value = actual;
      aplicar(actual);
    }

    ctrl.addEventListener('pointerdown', sincronizar);
    ctrl.addEventListener('keydown', sincronizar);
    ctrl.addEventListener('input', function () {
      activar();                 // no reescribe el valor: respeta el gesto
      aplicar(+ctrl.value);
    });

    caja.style.setProperty('--nm-pct', '0%');
    escena.appendChild(caja);
  }

  function arrancar() {
    repararAnclas();
    if (DIAG === 'sin-animacion') return;
    var nodos = document.querySelectorAll('[data-numa-lampara]');
    for (var i = 0; i < nodos.length; i++) iniciar(nodos[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
